import { render, staticRenderFns } from "./CompanyOverviewControls.vue?vue&type=template&id=72bd2145&scoped=true&"
import script from "./CompanyOverviewControls.vue?vue&type=script&lang=js&"
export * from "./CompanyOverviewControls.vue?vue&type=script&lang=js&"
import style0 from "./CompanyOverviewControls.vue?vue&type=style&index=0&id=72bd2145&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bd2145",
  null
  
)

export default component.exports